import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MODAL_DATA, MODAL_REF } from './modal.service';
import { ToastService } from '../toast/toast.service';

@Component({
  selector: 'app-base-modal',
  template: ''
})
export abstract class BaseModalComponent<T = unknown> implements OnInit {
  protected modalRef = inject(MODAL_REF);
  protected data: T = inject(MODAL_DATA, { optional: true }) as T;
  protected toastService = inject(ToastService);
  protected fb = inject(FormBuilder);
  protected destroyRef = inject(DestroyRef);

  public isLoading = false;
  public isSaving = false;

  ngOnInit(): void {
    this.initializeModal();
  }

  protected initializeModal(): void {}

  protected validateForm(form: FormGroup): boolean {
    if (form.invalid) {
      form.markAllAsTouched();
      return false;
    }
    return true;
  }

  protected startLoading(form?: FormGroup): void {
    this.isLoading = true;
    if (form) {
      form.disable();
    }
  }

  protected stopLoading(form?: FormGroup): void {
    this.isLoading = false;
    if (form) {
      form.enable();
    }
  }

  protected startSaving(form?: FormGroup): void {
    this.isSaving = true;
    if (form) {
      form.disable();
    }
  }

  protected stopSaving(form?: FormGroup): void {
    this.isSaving = false;
    if (form) {
      form.enable();
    }
  }

  protected closeSuccess(message: string, result: unknown = 'success'): void {
    this.toastService.success(message);
    this.modalRef.close(result);
  }

  protected handleError(message: string, form?: FormGroup): void {
    this.isLoading = false;
    this.isSaving = false;
    if (form) {
      form.enable();
    }
    this.toastService.error(message);
  }

  public cancel(): void {
    this.modalRef.close('cancel');
  }

  protected close(result?: unknown): void {
    this.modalRef.close(result);
  }
}
